const intlFormat = (
  amountMajor: number,
  currency: string | null | undefined,
  fractionDigits: number,
): string => {
  const format = (code: string) =>
    new Intl.NumberFormat("en-US", {
      style: "currency",
      currency: code,
      minimumFractionDigits: fractionDigits,
      maximumFractionDigits: fractionDigits,
    }).format(amountMajor);
  try {
    return format((currency || "USD").toUpperCase());
  } catch {
    // Unknown code from bad org data: fall back rather than crash the widget.
    return format("USD");
  }
};

/**
 * Formats a minor-unit amount in the org's ISO-4217 currency. Callers assume
 * two-decimal currencies (minor = major * 100), matching the API contract.
 */
export function formatMinorAmount(
  amountMinor: number,
  currency?: string | null,
): string {
  return intlFormat(amountMinor / 100, currency, 2);
}

/** Formats a major-unit amount (dollars, pounds) with two decimals: `£12.00`. */
export function formatMajorAmount(
  amount: number,
  currency?: string | null,
): string {
  return intlFormat(amount, currency, 2);
}

/**
 * Compact major-unit price for cards and lists: whole amounts drop the
 * decimals (`£129`), fractional ones keep two (`£12.50`).
 */
export function formatShortAmount(
  amount: number,
  currency?: string | null,
): string {
  return intlFormat(amount, currency, Number.isInteger(amount) ? 0 : 2);
}
